import React, { useState } from "react";
import { toast } from "react-toastify";
import Search from "../../../components/form/Search";
import Table from "../../../components/elements/table/Table";
import { setTitle } from "../../../helpers/MetaTag";
import { handleFilterChange, removeDuplicateFromArray } from "../../../helpers";

import useFetch from "../../../hooks/useFetch";
import { useDebounce } from "../../../hooks/useDebounce";
import LimitSelect from "../../../components/elements/LimitSelect";
import useMutation from "../../../hooks/useMutation";
import Switch from "../../../components/form/Switch";
import Badge from "../../../components/elements/Badge";

import dayjs from "dayjs";
import DeleteModal from "../../../components/common/DeleteModal";

import Button from "../../../components/form/Button";
import {
  userCollectionDelete,
  userCollectionList,
} from "../../../services/userCollectionService";
import { userList } from "../../../services/userService";
import { useNavigate } from "react-router-dom";

const UserCollection = () => {
  setTitle("MemoryDoodle Admin | User's Collections");
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });

  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const [userFilters, setUserFilters] = useState({
    limit: 100,
    page: 1,
  });
  const [userSearch, setUserSearch] = useState("");

  const debouncedUserSearch = useDebounce(userSearch, 300);
  const {
    data: users,
    error: userError,
    isLoading: userLoading,
    updateData: updateUsers,
    isFetching: isFetchingUsers,
    refetch: refetchUsers,
  } = useFetch({
    dependencies: ["users", userFilters, debouncedUserSearch],
    fetchFunction: async () => {
      const res = await userList({
        ...userFilters,
        // roleCode: "USER",
        ...(debouncedUserSearch && { keyword: debouncedUserSearch }),
      });

      if (res?.docs?.status === 200) {
        const newData = res?.docs?.data || [];
        return {
          ...res?.docs,
          data:
            userFilters.page > 1
              ? removeDuplicateFromArray(
                  [...(users?.data || []), ...newData],
                  "_id"
                )
              : newData, // if page = 1, reset data
        };
      } else {
        return {
          data: [],
          metadata: {
            totalDocs: 0,
            totalPages: 0,
            page: 1,
          },
        };
      }
    },
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["userCollection", filters, search],
    fetchFunction: async () => {
      const { status = [], userId = [], ...restFilters } = filters || {};
      const res = await userCollectionList({
        ...restFilters,
        ...Object.fromEntries(userId.map((val, i) => [`userId[${i}]`, val])),
        ...Object.fromEntries(status.map((val, i) => [`status[${i}]`, val])),
        ...(search && { keyword: search }),
      });
      return res?.docs;
    },
  });

  //  user Collection status change handler =================>
  //   const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
  //     useMutation({
  //       mutationFn: async ({ id, status }) => {
  //         const res = await collectionTemplateStatusChange({
  //           ids: [id],
  //           status,
  //         });
  //         return { res, payload: { id, status } };
  //       },
  //       onSuccess: ({ res, payload }) => {
  //         if (res?.status !== 200) {
  //           updateData((pre) => {
  //             pre.data = (pre?.data || []).map((elm) =>
  //               elm?._id === payload?.id
  //                 ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
  //                 : elm
  //             );
  //             return { ...pre };
  //           });
  //         }
  //       },
  //       onError: (error) => {
  //         console.log(error);
  //       },
  //     });

  const tableHeadData = [
    {
      _id: 1,
      name: "Name",
      align: "left",
    },
    {
      _id: 3,
      name: "Content",
      align: "left",
    },
    {
      _id: 2,
      name: "User Name",
      align: "left",
      isFilter: true,
      isFilterSearch: true,
      filterSearch: (e) => setUserSearch(e),
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            userId: val.map((item) => item.value),
          }));
        } else {
          setFilters((pre) => {
            delete pre.userId;
            return { ...pre };
          });
        }
      },
      filterData: (users?.data || []).map((user) => ({
        value: user._id,
        name: `${user.firstName} ${user.lastName}`,
        type: "checkbox",
      })),
      // onScroll: (e) => loadData(e, users, setUserFilters),
      onScroll: (e) => console.log(e),
    },
    {
      _id: 4,
      name: "User Email",
      align: "left",
    },

    // {
    //   _id: 4,
    //   name: "Cover Content",
    //   align: "left",
    // },

    {
      _id: 5,
      name: "Action",
      align: "right",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          tdClasses: "!min-w-[100px]",
          data:
            (
              <div
                dangerouslySetInnerHTML={{
                  //   __html: emailName[item?.code] || "-",
                  __html: item?.name || "-",
                }}
              ></div>
            ) || "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div
                dangerouslySetInnerHTML={{
                  __html: item?.pageDetail?.name || "-",
                }}
              ></div>
            ) || "-",
        },
        {
          _id: 2,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            `${item?.userDetail?.firstName || ""} ${
              item?.userDetail?.lastName || ""
            }`.trim() || "-",
          image: item?.userDetail?.image?.url,
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div
                dangerouslySetInnerHTML={{
                  __html: item?.userDetail?.email || "-",
                }}
              ></div>
            ) || "-",
        },
        // {
        //   _id: 4,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data:
        //     (
        //       <div
        //         dangerouslySetInnerHTML={{
        //           __html: item?.pageDetail?.content || "-",
        //         }}
        //       ></div>
        //     ) || "-",
        // },

        // {
        //   _id: 4,
        //   type: "text",
        //   align: "left",
        //   tdClasses: "!min-w-[50px]",
        //   data: (
        //     <div className="flex gap-2 items-center">
        //       <Switch
        //         className={
        //           "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
        //         }
        //         checked={item?.status === 1}
        //         onChange={() => {
        //           updateData((pre) => {
        //             pre.data = (pre?.data || []).map((elm) =>
        //               elm?._id === item?._id
        //                 ? { ...elm, status: elm?.status === 1 ? 2 : 1 }
        //                 : elm
        //             );
        //             return { ...pre };
        //           });
        //           statusChangeHandler({
        //             id: item?._id,
        //             status: item?.status === 1 ? 2 : 1,
        //           });
        //         }}
        //       />
        //       <Badge
        //         type={item?.status === 1 ? "success" : "danger"}
        //         label={item?.status === 1 ? "Active" : "Inactive"}
        //       />
        //     </div>
        //   ),
        // },
        // {
        //   _id: 8,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: dayjs(item?.createdAt).format("DD MMM, YYYY") || "-",
        // },
        {
          _id: 5,
          type: "action",
          align: "left",
          tdClasses: "!min-w-[50px]",
          actionData: [
            // {
            //   _id: 1,
            //   name: "Edit",
            //   icon: "fa-regular fa-pen-to-square",
            //   onClick: () => {
            //     setModalOpen({ isOpen: true, data: item });
            //   },
            //   standout: false,
            // },
            {
              _id: "details",
              name: "Details",
              icon: "fa-regular fa-eye",
              standout: false,
              onClick: () => {
                navigate(`/admin/user-collections/details/${item._id}`);
              },
            },
            {
              _id: 3,
              name: "Cover Content",
              icon: "fa-regular fa-image",
              standout: false,
              onClick: () => {
                navigate(`/admin/user-collections/cover-content/${item._id}`, {
                  state: { content: item?.pageDetail?.content },
                });
              },
            },
            {
              _id: 2,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  // add or edit user Collection =================>
  //   function applicationFormManageResponse(res) {
  //     if (res?.status === 200 || res?.status === 201) {
  //       if (res?.status === 201) {
  //         if (filters?.page === 1) {
  //           updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
  //           refetch();
  //         } else {
  //           setFilters((pre) => ({ ...pre, page: 1 }));
  //         }
  //       }
  //       if (res?.status === 200) {
  //         updateData((pre) => ({
  //           ...pre,
  //           data: pre?.data?.map((item) =>
  //             item?._id === res?.data?._id ? res?.data : item
  //           ),
  //         }));
  //       }
  //       setModalOpen({ isOpen: false, data: null });
  //     } else {
  //       toast.warning(res?.message);
  //     }
  //   }
  //   user Collection delete handler =================>
  // const { mutate: deleteHandler, isPending: deletePending } = useMutation({
  //   mutationFn: async (payload) => {
  //     const res = await userCollectionDelete({
  //       ids: Array.isArray(payload) ? payload : [payload],
  //     });
  //     return { res, payload: Array.isArray(payload) ? payload : [payload] };
  //   },
  //   onSuccess: ({ res, payload }) => {
  //     if (res?.status === 200) {
  //       setDeleteModal({ isOpen: false, data: null });
  //       updateData((pre) => {
  //         pre.data = (pre?.data || [])?.filter(
  //           (item) => !payload?.includes(item?._id)
  //         );
  //         return { ...pre };
  //       });
  //       if (data?.metadata?.totalDocs > filters?.limit) {
  //         refetch();
  //       }
  //     }
  //   },
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async ({ collectionId, userId }) => {
      const res = await userCollectionDelete({
        collectionId,
        userId,
      });
      return { res, collectionId };
    },
    onSuccess: ({ res, collectionId }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || []).filter(
            (item) => !collectionId.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  //   async function userCollectionOrderingHandler(newData, oldData) {
  //     console.log({ newData, oldData });

  //     const ordering_data = newData?.map((item, i) => ({
  //       id: item?._id,
  //       ordering: i,
  //     }));
  //     const res = await collectionTemplateOrdering({ ordering_data });
  //     if (res?.status !== 200) {
  //       updateData((pre) => {
  //         pre.data = oldData;
  //         return { ...pre };
  //       });
  //     }
  //   }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          User's Collections
        </div>

        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 0, setFilters);
              }}
            />
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(val) => {
          console.log(val);
        }}
        // originalData={[...(data?.data || [])]}
        // setOriginalData={(data) =>
        //   updateData((pre) => {
        //     pre.data = data;
        //     return { ...pre };
        //   })
        // }
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />

      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler({
            collectionId: [deleteModal?.data?._id],
            userId: deleteModal?.data?.userDetail?._id,
          });
        }}
      />
      {/* <ManageCollectionTemplateModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={applicationFormManageResponse}
      /> */}
    </div>
  );
};

export default UserCollection;
